import React from "react";

export const SummaryTermsAndActionsSection = ({
  agreedToTerms,
  termsError,
  onTermsAgreementChange,
  onTermsOpen,
  isPaymentBlockedPendingPaperApproval,
  paymentBlockedPaperStatusMessage,
  onBack,
  totalOutstanding,
  onProceedToPayment,
  saving,
  canSubmitPostPaymentAbstract,
  onSubmitPostPaymentAbstract,
}) => (
  <>
    <div className={`terms-checkbox-container ${termsError ? "error" : ""}`}>
      <input
        type="checkbox"
        id="terms-checkbox"
        checked={agreedToTerms}
        onChange={(event) => onTermsAgreementChange(event.target.checked)}
      />
      <label htmlFor="terms-checkbox" className="terms-checkbox-label">
        I agree to the{" "}
        <span className="terms-link" onClick={onTermsOpen}>
          Terms & Conditions
        </span>
      </label>
    </div>
    {termsError && <div className="terms-error-message">{termsError}</div>}

    <div className="summary-actions">
      {isPaymentBlockedPendingPaperApproval && (
        <div
          className="registration-status warning"
          style={{ marginBottom: "10px" }}
        >
          ⏳ {paymentBlockedPaperStatusMessage}
        </div>
      )}

      <div className="summary-buttons">
        <button type="button" className="back-btn" onClick={onBack}>
          Back
        </button>

       
        {totalOutstanding > 0 ? (
          <button
            type="button"
            className="btn btn-primary"
            onClick={onProceedToPayment}
            disabled={saving || isPaymentBlockedPendingPaperApproval}
          >
            {saving ? "Saving..." : "Proceed to Payment →"}
          </button>
        ) : (
          <div className="registration-status success">
            ✅ All payments completed - No outstanding balance
          </div>
        )}

        {canSubmitPostPaymentAbstract && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSubmitPostPaymentAbstract}
            style={{
              marginTop: "10px",
              padding: "12px 20px",
              fontSize: "15px",
              fontWeight: "600",
              backgroundColor: "#28a745",
              border: "none",
              borderRadius: "6px",
              color: "white",
              cursor: "pointer",
            }}
          >
            📄 Submit Paper/Abstract →
          </button>
        )}
      </div>
    </div>
  </>
);
